import API from '@/Core.Service.Domain/Monitors/Egauges/API/index.ts';

import { ISite } from '@/Core.Service.Domain/Sites/Sites.Common/types/site.ts';
import { IEgaugeRegister } from '@/Core.Service.Domain/Monitors/Egauges/types/register';
import { IEgauge } from '@/Core.Service.Domain/Monitors/Egauges/types/egauge.ts';
import { IUnmappedRegisters } from '@/Core.Service.Domain/Monitors/Egauges/types/unmappedRegisters.ts';

interface IContext<T> {
  commit: (mutation: string, payload: T) => void;
}

const setSelectedSite = (context: IContext<ISite>, site: ISite) => {
  context.commit('SET_SELECTED_SITE', site);
};

const setRegistriesByEgaugeId = async (
  context: IContext<Partial<IEgaugeRegister[] | IUnmappedRegisters>>,
  eGaugeId: string | number
) => {
  try {
    const registers = await API.getRegistriesByEgaugeId(eGaugeId);
    const unmapped = await API.getUnmappedRegistersByEgaugeId(eGaugeId);
    context.commit('SET_UNMAPPED_REGISTERS', unmapped);
    context.commit('SET_REGISTRIES_BY_EGAUGE', registers);
  } catch (error) {
    return Promise.reject(error);
  }
};

type SiteLocation = {
  id: number;
  siteLocationName: string;
  siteId: number;
};
const setEgaugeInfoBySiteId = async (
  context: IContext<IEgauge>,
  data: { siteId: number; egaugeId: number }
) => {
  try {
    const { siteId, egaugeId } = data;
    const egaugesList = await API.getEgaugesForSite(siteId);
    const siteLocations = await API.getSiteLocationsBySiteId(siteId);
    const Egauge = await API.getEgaugeById(egaugeId);
    const foundEgauge: IEgauge = egaugesList.find(
      (egauge: IEgauge) => egauge.monitorId === egaugeId
    );

    const eGaugeInfo = {
      ...Egauge,
      ...foundEgauge,
    };
    const foundSiteLocation: SiteLocation = siteLocations.find(
      (siteLocation: SiteLocation) =>
        siteLocation.id === eGaugeInfo.siteLocationId
    );
    eGaugeInfo.siteLocationName = foundSiteLocation.siteLocationName;
    context.commit('SET_EGAUGE_INFO', eGaugeInfo);
  } catch (error) {
    Promise.reject(error);
  }
};

export default {
  setSelectedSite,
  setRegistriesByEgaugeId,
  setEgaugeInfoBySiteId,
};
